// Icon asset URLs (Vite will fingerprint in prod). Works in dev & prod.
import creditUrl from './credit.png?url';
import blackSpecialBarUrl from './black-special-bar.png?url';
import blackSpecialOreUrl from './black-special-ore.png?url';
import blackStoneBarUrl from './black-stone-bar.png?url';
import blackStoneOreUrl from './black-stone-ore.png?url';
import blueBarUrl from './blue-bar.png?url';
import blueOreUrl from './blue-ore.png?url';
import crystalBarUrl from './crystal-bar.png?url';
import crystalOreUrl from './crystal-ore.png?url';
import darkMatterUrl from './dark-matter.png?url';
import goldenBarUrl from './golden-bar.png?url';
import goldenOreUrl from './golden-ore.png?url';
import implantUrl from './implant.png?url';
import mysteryCardUrl from './mystery-card.png?url';
import stoneBarUrl from './stone-bar.png?url';
import stoneBar2Url from './stone-bar2.png?url';
import stoneOreUrl from './stone-ore.png?url';
import vortexUrl from './vortex.png?url';

export const ITEM_ICON_URLS = {
  'credit.png': creditUrl,
  'black-special-bar.png': blackSpecialBarUrl,
  'black-special-ore.png': blackSpecialOreUrl,
  'black-stone-bar.png': blackStoneBarUrl,
  'black-stone-ore.png': blackStoneOreUrl,
  'blue-bar.png': blueBarUrl,
  'blue-ore.png': blueOreUrl,
  'crystal-bar.png': crystalBarUrl,
  'crystal-ore.png': crystalOreUrl,
  'dark-matter.png': darkMatterUrl,
  'golden-bar.png': goldenBarUrl,
  'golden-ore.png': goldenOreUrl,
  'implant.png': implantUrl,
  'mystery-card.png': mysteryCardUrl,
  'stone-bar.png': stoneBarUrl,
  'stone-bar2.png': stoneBar2Url,
  'stone-ore.png': stoneOreUrl,
  'vortex.png': vortexUrl,
} as const;

/**
 * Get the correct URL for an item icon
 * @param iconPath - Path like "icons/credit.png" or "credit.png"
 * @returns Proper Vite URL that works in dev and prod
 */
export function getItemIconUrl(iconPath: string): string {
  // Extract filename from path like "icons/credit.png" -> "credit.png"
  const filename = iconPath.includes('/') ? iconPath.split('/').pop() || 'credit.png' : iconPath;

  // Return the proper Vite URL
  return ITEM_ICON_URLS[filename as keyof typeof ITEM_ICON_URLS] || creditUrl;
}
